import { counterReducer } from './counter/slice';

const rootReducer = {
  counter: counterReducer,
};

export default rootReducer;
